/**
 * Which engagement is current — the id only. What it IS comes from the server,
 * via React Query (`queries/audits.ts`).
 */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const STORAGE_KEY = 'reconcilio.audit';

/* Private browsing, or site data blocked. Selection just will not persist. */
function read(): string | null {
	try {
		return localStorage.getItem(STORAGE_KEY);
	} catch {
		return null;
	}
}

const slice = createSlice({
	name: 'workspace',
	initialState: { selected: read() },
	reducers: {
		/* Writing to storage in a reducer is a side effect RTK tolerates. A
       second persisted key is the signal to move this to middleware. */
		selectAudit(state, action: PayloadAction<string>) {
			if (state.selected === action.payload) return;
			state.selected = action.payload;
			try {
				localStorage.setItem(STORAGE_KEY, action.payload);
			} catch {
				/* Not persisting is acceptable; losing the session is not. */
			}
		},
		/** On a 401 — a signed-out session must not leave the NEXT person to sign
		 *  in on this device looking at a stale engagement selection. */
		clearSelection(state) {
			state.selected = null;
			try {
				localStorage.removeItem(STORAGE_KEY);
			} catch {
				/* Not clearing is a stale value, not a crash. */
			}
		},
	},
});

export const { selectAudit, clearSelection } = slice.actions;
export default slice.reducer;
